import { Routes, Route } from "react-router-dom"
import { GuestLayout } from "./components/GuestLayout"
import { AuthLayout } from "./components/AuthLayout"
import { Login } from "./pages/Login"
import { PasswordDimenticata } from "./pages/PasswordDimenticata"
import { ResetPassword } from "./pages/ResetPassword"
import { AttivazioneAccount } from "./pages/AttivazioneAccount"
import { Home } from "./pages/Home"

import Esemplari from "./pages/Esemplari"
import OperaCreate from "./pages/Opere/OperaCreate"
import OperaUpdate from "./pages/Opere/OperaUpdate"
import PersonaCreate from "./pages/Persone/PersonaCreate"
import PersonaUpdate from "./pages/Persone/PersonaUpdate"
import CittaCreate from "./pages/Citta/CittaCreate"
import EdizioneCreate from "./pages/Edizioni/EdizioneCreate"
import EdizioneUpdate from "./pages/Edizioni/EdizioneUpdate"
import Facsimili from "./pages/Facsimili"
import Paratesti from "./pages/Paratesti"
import { MagikUI } from "@inmagik/magik-ui"
import UtenteCreate from "./pages/Utenti/UtenteCreate"
import UtenteUpdate from "./pages/Utenti/UtenteUpdate"
import Immagini from "./pages/Immagini"
import Biblioteche from "./pages/Biblioteche/Biblioteche"
import BibliotecaCreate from "./pages/Biblioteche/BibliotecaCreate"
import BibliotecaUpdate from "./pages/Biblioteche/BibliotecaUpdate"
import Edizioni from "./pages/Edizioni/Edizioni"
import Persone from "./pages/Persone/Persone"
import Opere from "./pages/Opere/Opere"
import Utenti from "./pages/Utenti/Utenti"
import Citta from "./pages/Citta/Citta"
import CittaUpdate from "./pages/Citta/CittaUpdate"
import ImmagineCreate from "./pages/Immagini/ImmagineCreate"
import ImmagineUpdate from "./pages/Immagini/ImmagineUpdate"
import EsemplareCreate from "./pages/Esemplari/EsemplareCreate"
import EsemplareUpdate from "./pages/Esemplari/EsemplareUpdate"
import FacsimileCreate from "./pages/Facsimili/FacsimileCreate"
import FacsimileUpdate from "./pages/Facsimili/FacsimileUpdate"
import ParatestoCreate from "./pages/Paratesti/ParatestoCreate"
import ParatestoUpdate from "./pages/Paratesti/ParatestoUpdate"
import Tags from "./pages/Tags/Tags"
import TagCreate from "./pages/Tags/TagCreate"
import TagUpdate from "./pages/Tags/TagUpdate"
import Profilo from "./pages/Profilo/Profilo"
import Formati from "./pages/Formati/Formati"
import FormatoCreate from "./pages/Formati/FormatoCreate"
import FormatoUpdate from "./pages/Formati/FormatoUpdate"
import TipologieImmagini from "./pages/TipologieImmagini/TipologieImmagini"
import TipologiaImmagineCreate from "./pages/TipologieImmagini/TipologiaImmagineCreate"
import TipologiaImmagineUpdate from "./pages/TipologieImmagini/TipologiaImmagineUpdate"
import Tecniche from "./pages/Tecniche/Tecniche"
import TecnicaCreate from "./pages/Tecniche/TecnicaCreate"
import TecnicaUpdate from "./pages/Tecniche/TecnicaUpdate"
import TextsConfig from "./pages/TextsConfig/TextsConfig"
import GruppiDiRicerca from "./pages/GruppoDiRicerca"
import GruppoDiRicercaUpdate from "./pages/GruppoDiRicerca/GruppoDiRicercaUpdate"
import GruppoDiRicercaCreate from "./pages/GruppoDiRicerca/GruppoDiRicercaCreate"
import Atlanti from "./pages/Atlanti/Atlanti"
import AtlanteCreate from "./pages/Atlanti/AtlanteCreate"
import AtlanteUpdate from "./pages/Atlanti/AtlanteUpdate"
import Tavole from "./pages/Tavole/Tavole"
import TavolaCreate from "./pages/Tavole/TavolaCreate"
import TavolaUpdate from "./pages/Tavole/TavolaUpdate"
import RelazioniAtlante from "./pages/RelazioniAtlante/RelazioniAtlante"
import RelazioniAtlanteCreate from "./pages/RelazioniAtlante/RelazioniAtlanteCreate"
import RelazioniAtlanteUpdate from "./pages/RelazioniAtlante/RelazioniAtlanteUpdate"

export function Navigation() {
  return (
    <MagikUI>
      <Routes>
        <Route path="/" element={<AuthLayout redirect_to="/login" />}>
          <Route index element={<Home />}></Route>
          <Route path="/utenti/utenti" element={<Utenti />}></Route>
          <Route path="/utenti/utenti/new" element={<UtenteCreate />}></Route>
          <Route path="/utenti/utenti/:id" element={<UtenteUpdate />}></Route>
          <Route path="/opere/opere" element={<Opere />}></Route>
          <Route path="/opere/opere/new" element={<OperaCreate />}></Route>
          <Route path="/opere/opere/:id/*" element={<OperaUpdate />}></Route>
          <Route path="/opere/persone" element={<Persone />}></Route>
          <Route path="/opere/persone/new" element={<PersonaCreate />}></Route>
          <Route path="/opere/persone/:id" element={<PersonaUpdate />}></Route>
          <Route path="/edizioni/edizioni" element={<Edizioni />}></Route>
          <Route path="/edizioni/edizioni/new" element={<EdizioneCreate />}></Route>
          <Route path="/edizioni/edizioni/:id/*" element={<EdizioneUpdate />}></Route>
          <Route path="/citta/citta" element={<Citta />}></Route>
          <Route path="/citta/citta/:id" element={<CittaUpdate />}></Route>
          <Route path="/citta/citta/new" element={<CittaCreate />}></Route>
          <Route path="/edizioni/esemplari" element={<Esemplari />}></Route>
          <Route path="/edizioni/esemplari/new" element={<EsemplareCreate />}></Route>
          <Route path="/edizioni/esemplari/:id" element={<EsemplareUpdate />}></Route>
          <Route path="/edizioni/facsimili" element={<Facsimili />}></Route>
          <Route path="/edizioni/facsimili/new" element={<FacsimileCreate />}></Route>
          <Route path="/edizioni/facsimili/:id" element={<FacsimileUpdate />}></Route>
          <Route path="/edizioni/paratesti" element={<Paratesti />}></Route>
          <Route path="/edizioni/paratesti/new" element={<ParatestoCreate />}></Route>
          <Route path="/edizioni/paratesti/:id" element={<ParatestoUpdate />}></Route>
          <Route path="/edizioni/immagini" element={<Immagini />}></Route>
          <Route path="/edizioni/immagini/new" element={<ImmagineCreate />}></Route>
          <Route path="/edizioni/immagini/:id" element={<ImmagineUpdate />}></Route>
          <Route path="/edizioni/formati" element={<Formati />}></Route>
          <Route path="/edizioni/formati/new" element={<FormatoCreate />}></Route>
          <Route path="/edizioni/formati/:id" element={<FormatoUpdate />}></Route>
          <Route path="/biblioteche/biblioteche" element={<Biblioteche />}></Route>
          <Route path="/biblioteche/biblioteche/new" element={<BibliotecaCreate />}></Route>
          <Route path="/biblioteche/biblioteche/:id" element={<BibliotecaUpdate />}></Route>
          <Route path="/tags/tags" element={<Tags />}></Route>
          <Route path="/tags/tags/new" element={<TagCreate />}></Route>
          <Route path="/tags/tags/:id" element={<TagUpdate />}></Route>
          <Route path="/tipologie-immagini/tipologie-immagini" element={<TipologieImmagini />}></Route>
          <Route path="/tipologie-immagini/tipologie-immagini/new" element={<TipologiaImmagineCreate />}></Route>
          <Route path="/tipologie-immagini/tipologie-immagini/:id" element={<TipologiaImmagineUpdate />}></Route>
          <Route path="/tecniche-immagini/tecniche-immagini" element={<Tecniche />}></Route>
          <Route path="/tecniche-immagini/tecniche-immagini/new" element={<TecnicaCreate />}></Route>
          <Route path="/tecniche-immagini/tecniche-immagini/:id" element={<TecnicaUpdate />}></Route>
          <Route path="/gruppi-di-ricerca/gruppi-di-ricerca" element={<GruppiDiRicerca />}></Route>
          <Route path="/gruppi-di-ricerca/gruppi-di-ricerca/new" element={<GruppoDiRicercaCreate />}></Route>
          <Route path="/gruppi-di-ricerca/gruppi-di-ricerca/:id" element={<GruppoDiRicercaUpdate />}></Route>
          <Route path="/atlanti/atlanti" element={<Atlanti />}></Route> 
          <Route path="/atlanti/atlanti/new" element={<AtlanteCreate />}></Route>
          <Route path="/atlanti/atlanti/:id/*" element={<AtlanteUpdate />}></Route>
          <Route path="/atlanti/tavole" element={<Tavole />}></Route>
          <Route path="/atlanti/tavole/new" element={<TavolaCreate />}></Route>
          <Route path="/atlanti/tavole/:id/*" element={<TavolaUpdate />}></Route>
          <Route path="/atlanti/relazioni" element={<RelazioniAtlante />}></Route>
          <Route path="/atlanti/relazioni/new" element={<RelazioniAtlanteCreate />}></Route>
          <Route path="/atlanti/relazioni/:id" element={<RelazioniAtlanteUpdate />}></Route>
          {/* <Route path="/atlanti/tavole/:id" element={<TavolaUpdate />}></Route> */}
          <Route path="/testi/testi" element={<TextsConfig />}></Route>
          <Route path="/profilo" element={<Profilo />}></Route>
        </Route>
        <Route path="/login" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<Login />}></Route>
        </Route>
        <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<PasswordDimenticata />}></Route>
        </Route>
        <Route path="/reset-password" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<ResetPassword />}></Route>
        </Route>
        <Route path="/attivazione-account" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<AttivazioneAccount />}></Route>
        </Route>
      </Routes>
    </MagikUI>
  )
}
